// Layout
export * from "./layout/actions";

// Authentication module
export * from "./auth/register/actions";
export * from "./auth/login/actions";
export * from "./auth/forgetpwd/actions";

// Company Settings - with prefixed exports to avoid conflicts
export {
  getLocations as getUsersLocations,
  locationListSuccessful as usersLocationListSuccessful,
  getSubLocations as getUsersSubLocations,
  sublocationListSuccessful as usersSublocationListSuccessful,
  getDepartment as getUsersDepartment,
  DepartmentListSuccessful as usersDepartmentListSuccessful,
  getUsers,
  usersListSuccessful,
  getRowUserData,
  UserRowDataSuccessful,
  getGroupsList,
  groupsListSuccessful,
  getPaginationGroupsList,
  paginationGroupsListSuccessful,
  getDeptSelectFiled,
  removeDeptSelectFiled,
  getLocSelectFiled,
  removeLocSelectFiled,
  SelecteChangeDeptValue,
  SelecteChangeLocValue,
  MultiSelecteChangeSubLocValue,
  getHODChecked,
  InputChangeValue as usersInputChangeValue,
  SelecteChangeValue as usersSelecteChangeValue,
  MultiSelecteChangeValue as usersMultiSelecteChangeValue,
  userAdd,
  userAddSuccessfull,
  userEdit,
  userDelete,
  groupAdd,
  groupAddSuccessfull,
  model_open as usersModelOpen,
  model_close as usersModelClose,
  SetParams as usersSetParams,
  SetProfileParams,
  SetProfilePaginationParams,
  apiError as usersApiError,
  updateGroupsList,
} from "./CompanySettings/users/actions";

// Export remaining Company Settings modules with namespace
export * from "./CompanySettings/Profiles/actions";
export * from "./menu/actions";

// Vendor Quotation - with namespace to avoid conflicts
export * from "./VendorQuotation/actions";
export * from "./VendorPO/actions";

// Other modules with namespace
export * from "./Mini/actions";
export * from "./UserProfile/actions";

// Masters - with prefixed exports to avoid conflicts
export {
  getMenus,
  MenuListSuccessful,
  InputChangeValue as menusInputChangeValue,
  MenuAdd,
  MenuAddSuccessful,
  MenuRowData,
  MenuDataSuccessful,
  MenuDelete,
  SetEditData as menusSetEditData,
  model_open as menusModelOpen,
  model_close as menusModelClose,
  apiError as menusApiError,
} from "./Masters/Menus/actions";

// Export remaining Masters modules with namespace
export * from "./Masters/MenuItems/actions";
export * from "./Masters/MastersMenu/actions";
export * from "./Masters/Locations/actions";
export * from "./Masters/quality/actions";
export * from "./Masters/ProductQuality/action";
export * from "./Masters/SubLocations/actions";
export * from "./Masters/OrderLocations/action";
export * from "./Masters/OrderLocationTemplate/actions";
export * from "./Masters/Departments/actions";
export * from "./Masters/ProductGroups/actions";
export * from "./Masters/Products/actions";
export * from "./Masters/Vendors/actions";
export * from "./Masters/Category/actions";
export * from "./Masters/Section/actions";

export {
  getBasicUnits,
  BasicUnitListSuccessful,
  BasicUnitAdd,
  BasicUnitAddSuccessful,
  BasicUnitEdit,
  BasicUnitEditSuccessful,
  BasicUnitDelete,
  SetEditData as basicUnitSetEditData,
  model_open as basicUnitModelOpen,
  model_close as basicUnitModelClose,
  apiError as basicUnitApiError,
} from "./Masters/BasicUnit/actions";

// Export remaining modules with prefixed names to avoid conflicts
export * from "./Masters/Taxs/actions";
export * from "./Masters/PrefixCode/actions";
export * from "./MaterialRequest/actions";
export * from "./PurchaseIndent/actions";
export * from "./RequetForQuotation/actions";
export * from "./Quotation/actions";
export * from "./CompareQuotation/actions";
export * from "./PurchaseOrder/actions";
export * from "./ingatepass/actions";
export * from "./Reports/actions";
export * from "./Dashboard/actions";
export * from "./Notification/actions";
export * from "./System/actions";
export * from "./Audit_Report/actions";

export * from "./settings/ImportExport/actions";
